import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Hero } from './heroSection/Hero';
import { AIUsage } from './AIUsageSection/AIUsage';
import { Highlights } from './highlightsSection/Highlights';
import { BottomSection } from './bottomCtaSection/BottomSection';
import { Vision } from './vision/Vision';
// import { Footer } from 'components/footer/Footer';
// import BuyMeACoffee from './BuyMeACoffee';
import { FAQSection, faqData } from './faq/FAQ';
import { SEO } from 'components/seo/SEO';
import { softwareApplicationJsonLd } from 'components/seo/organizationSchema';
import routeManifest from 'routes/routeManifest.json';
import './Home.css';

const homeRoute = routeManifest.find((route) => route.path === '/')!;

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqData.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.plainAnswer,
    },
  })),
};

export const Home: FC = () => {
  const location = useLocation();

  // Scroll to a section when linked with a hash, e.g. /#faq from the navbar or footer
  useEffect(() => {
    if (!location.hash) return;
    document.getElementById(location.hash.slice(1))?.scrollIntoView({ behavior: 'smooth' });
  }, [location.hash, location.key]);

  return (
    <div className='home'>
      <SEO
        title={homeRoute.title}
        description={homeRoute.description}
        path={homeRoute.path}
        jsonLd={[softwareApplicationJsonLd, faqJsonLd]}
      />
      <Hero />
      <AIUsage />
      <Highlights />
      <FAQSection />
      <Vision />
      <BottomSection />
      {/* <Footer /> */}
    </div>
  );
};
